import {
  getJson,
  putJson,
  postJson,
  del
} from '../fetch';
import API_BASE_PATH from './basePath';
import { stringifyURLParams } from '../util';

export const getLatestSchemaPartVersionsBySchemaId = (surveySchemaId) => getJson(`${API_BASE_PATH}/survey-schema-parts/?latestBySchemaId=${surveySchemaId}`);

export const getSurveySchemaPart = (id) => getJson(`${API_BASE_PATH}/survey-schema-parts/${id}`);

export const getSurveySchemaParts = ({ type, page = 0 }) => {
  const params = stringifyURLParams({
    type, page
  });
  return getJson(`${API_BASE_PATH}/survey-schema-parts?${params}`);
};

export const getSurveySchemaPartUsage = (surveyPartId) => getJson(`${API_BASE_PATH}/survey-schema-parts/${surveyPartId}/usage`);

export const getSurveySchemaPartVersion = (surveyPartId, version) =>
  getJson(`${API_BASE_PATH}/survey-schema-parts/${surveyPartId}/versions/${version}`);

export const getOrCheckSurveySchemaPartCode = (suggestion) => {
  let requestUrl = 'survey-schema-parts/codes';

  if (suggestion) {
    requestUrl = `${requestUrl}?suggestion=${suggestion}`;
  }

  return getJson(`${API_BASE_PATH}/${requestUrl}`);
};

export const postSurveySchemaPart = (data) => postJson(`${API_BASE_PATH}/survey-schema-parts`, data);

export const putSurveySchemaPart = (schemaPartId, data) => putJson(`${API_BASE_PATH}/survey-schema-parts/${schemaPartId}`, data);

export const postSchemaPartVersion = (oldSchemaPartId, data) =>
  postJson(`${API_BASE_PATH}/survey-schema-parts/${oldSchemaPartId}/versions`, data);

export const postVariableExtraInfo = (extraInfo) => postJson(`${API_BASE_PATH}/variable-extra-info`, extraInfo);
export const deleteVariableExtraInfo = (extraInfoId) => del(`${API_BASE_PATH}/variable-extra-info/${extraInfoId}`);
